<template>
  <div class="delzhgl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            {{ dealerDetail.all_name }}的账户
          </div>
          <div v-loading="accountLoading" class="card-content">
            <el-table
              :data="accountData"
              :show-header="false"
              :row-style="{cursor: 'pointer'}"
              row-class-name="not-rowline"
              style="width: 100%"
            >
              <el-table-column
                label="账户名称"
                width="80"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#000;">{{ scope.row.accountname }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="意向金"
                width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">意向金：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.inmon }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="样品预存款"
                width="170"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">样品预存款：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.leftJoin }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="加盟费"
                width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">加盟费：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.insure }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="账户余额"
                width="170"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">账户余额：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.balance }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="冲业绩余额"
                width="170"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">冲业绩余额：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.achievement_balance }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="业绩/支票返点"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">业绩/支票返点：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.rebate_balance }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="售后赔款"
                min-width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">售后赔款：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.after_balance }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="报备金"
                min-width="150"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">报备金：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" style="margin-right: 6px;" />{{ scope.row.report_balance }}</span>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="margin-top: 20px">
        <div class="card-body">
          <el-tabs v-model="activeName">
            <!-- 账户历史 -->
            <el-tab-pane :label="dealerDetail.accountname" name="first">
              <div class="card-content">
                <div style="margin-top: 10px;">
                  <el-form :inline="true" size="small" :model="receiptForm">
                    <el-form-item label="日期">
                      <el-date-picker
                        v-model="receiptForm.time"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      />
                    </el-form-item>
                    <el-form-item label="收支类型">
                      <el-select v-model="receiptForm.type" style="width: 120px" filterable clearable @keyup.enter.native="searchReceipt">
                        <el-option label="支出" :value="0" />
                        <el-option label="收入" :value="1" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="关联类型">
                      <el-select v-model="receiptForm.asstype" style="width: 120px" filterable clearable @keyup.enter.native="searchReceipt">
                        <el-option label="无关联" :value="0" />
                        <el-option label="订单扣款" :value="1" />
                        <!-- <el-option label="物料单扣款" :value="2" /> -->
                        <el-option label="账户充值" :value="3" />
                        <!-- <el-option label="售后赔款" :value="4" /> -->
                        <el-option label="报备金转入" :value="5" />
                        <el-option label="物料收款" :value="6" />
                        <el-option label="冲业绩抵扣" :value="7" />
                        <el-option label="其他收款抵扣" :value="8" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="搜索关键字">
                      <el-input v-model="receiptForm.content" placeholder="关键字搜索" @keyup.enter.native="searchReceipt" />
                    </el-form-item>
                    <el-form-item>
                      <el-button icon="el-icon-search" type="primary" @click="searchReceipt">查询</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-loading="receiptloading">
                  <el-table
                    :data="receiptData"
                    :show-header="false"
                    :row-style="{cursor: 'pointer'}"
                    style="width: 100%"
                    @row-click="openReceiptDetails"
                  >
                    <el-table-column
                      label="时间"
                      width="180"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span><i class="el-icon-time" />{{ scope.row.time }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="关联类型"
                      width="120"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.asstype===0" :disable-transitions="true" size="mini" type="info">无关联</el-tag>
                        <el-tag v-if="scope.row.asstype===1" :disable-transitions="true" size="mini">订单扣款</el-tag>
                        <!-- <el-tag v-if="scope.row.asstype===2" :disable-transitions="true" size="mini" type="success">物料申请</el-tag> -->
                        <el-tag v-if="scope.row.asstype===3" :disable-transitions="true" size="mini" type="warning">账户充值</el-tag>
                        <!-- <el-tag v-if="scope.row.asstype===4" :disable-transitions="true" size="mini" type="warning">售后赔款</el-tag> -->
                        <el-tag v-if="scope.row.asstype===5" :disable-transitions="true" size="mini" type="warning">报备金转入</el-tag>
                        <el-tag v-if="scope.row.asstype===6" :disable-transitions="true" size="mini" type="warning">物料收款</el-tag>
                        <el-tag v-if="scope.row.asstype===7" :disable-transitions="true" size="mini" type="warning">冲业绩抵扣</el-tag>
                        <el-tag v-if="scope.row.asstype===8" :disable-transitions="true" size="mini" type="warning">其他收款抵扣</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="收支金额"
                      width="130"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===1" style="color:#67C23A;font-weight: 500">+ {{ scope.row.money }}</span>
                        <span v-if="scope.row.type===0" style="color:#F56C6C;font-weight: 500">- {{ scope.row.money }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="备注"
                      min-width="120"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.remark }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="280"
                      label="关联信息"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <!--asstype,关联类型，0-无关联（预存款），1-订单扣款，2-物料单扣款，3-账户充值，4-售后赔款，5-过期报备金划账 -->
                        <span v-if="scope.row.asstype===1" style="color:#99a9bf">订单号：</span>
                        <span v-if="scope.row.asstype===1&&scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined">{{ scope.row.ordernum }}</span>
                        <span v-if="scope.row.asstype===1&&scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">/ {{ scope.row.produnum }}</span>
                        <span v-if="scope.row.asstype===3" style="color:#99a9bf">收款账户：</span>
                        <span v-if="scope.row.asstype===3">{{ scope.row.accname }}（{{ scope.row.card }}）</span>
                        <span v-if="scope.row.asstype===5" style="color:#99a9bf">报备金：</span>
                        <span v-if="scope.row.asstype===5">{{ scope.row.darname }}</span>
                        <span v-if="scope.row.asstype===6" style="color:#99a9bf">物料单号：</span>
                        <span v-if="scope.row.asstype===6">{{ scope.row.manum }}</span>
                        <span v-if="scope.row.asstype===2" style="color:#99a9bf">申请单号：</span>
                        <span v-if="scope.row.asstype===2">{{ scope.row.manum }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="100"
                      align="right"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.asstype===1||scope.row.asstype===2||scope.row.asstype===3||scope.row.asstype===5||scope.row.asstype===8" style="font-size: 13px;color:#99a9bf">查看详情<i class="el-icon-d-arrow-right" /></span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="receiptForm.total>0"
                    style="margin-top: 20px"
                    background
                    :current-page="receiptForm.currentPage"
                    :page-sizes="[10, 20, 30]"
                    :page-size="receiptForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="receiptForm.total"
                    @size-change="handleSizeChangeReceipt"
                    @current-change="handleCurrentChangeReceipt"
                  />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="样品预存款" name="first2">
              <div class="card-content">
                <div style="margin-top: 10px;">
                  <el-form :inline="true" size="small" :model="joinForm">
                    <el-form-item label="日期">
                      <el-date-picker
                        v-model="joinForm.time"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      />
                    </el-form-item>
                    <el-form-item label="搜索关键字">
                      <el-input v-model="joinForm.content" placeholder="关键字搜索" @keyup.enter.native="searchJoin" />
                    </el-form-item>
                    <el-form-item>
                      <el-button icon="el-icon-search" type="primary" @click="searchJoin">查询</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-loading="joinloading">
                  <el-table
                    :data="joinData"
                    :show-header="false"
                    :row-style="{cursor: 'pointer'}"
                    style="width: 100%"
                    @row-click="openJoinDetails"
                  >
                    <el-table-column
                      label="操作时间"
                      width="180"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span><i class="el-icon-time" />{{ scope.row.time }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="类型"
                      width="100"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <el-tag :disable-transitions="true" size="mini">
                          {{ scope.row.paycontent == '样品预存款申请' ? '样品预存款' : scope.row.paycontent }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="金额"
                      width="130"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.crid===0" style="color:#67C23A;font-weight: 500">+ {{ scope.row.ordernum }}</span>
                        <span v-else style="color:#F56C6C;font-weight: 500">- {{ scope.row.money }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="备注"
                      min-width="300"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.remark }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="230"
                      label="关联信息"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.crid!==0" style="color:#99a9bf">订单号：</span>
                        <span v-if="scope.row.crid!==0">{{ scope.row.ordernum }} / {{ scope.row.produnum }}</span>
                        <span v-if="scope.row.crid===0" style="color:#99a9bf">样品预存款：</span>
                        <span v-if="scope.row.crid===0">{{ scope.row.ordernum }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="230"
                      label="地址"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.crid!==0" style="color:#99a9bf">地址：</span>
                        <span v-if="scope.row.crid!==0">{{ scope.row.address }}</span>
                        <span v-if="scope.row.crid===0" style="color:#99a9bf">加盟费：</span>
                        <span v-if="scope.row.crid===0">{{ scope.row.produnum }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="100"
                      align="right"
                      label="操作"
                    >
                      <template>
                        <span style="font-size: 13px;color:#99a9bf">查看详情 <i class="el-icon-d-arrow-right" /></span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="joinForm.total>0"
                    style="margin-top: 20px"
                    background
                    :current-page="joinForm.currentPage"
                    :page-sizes="[10, 20, 30]"
                    :page-size="joinForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="joinForm.total"
                    @size-change="handleSizeChangeJoin"
                    @current-change="handleCurrentChangeJoin"
                  />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="冲业绩" name="cyj">
              <div class="card-content">
                  <div style="margin-top: 10px;">
                    <el-form :inline="true" size="small" :model="cyjForm" @submit.native.prevent>
                      <el-form-item label="搜索关键字">
                        <el-input v-model="cyjForm.content" placeholder="关键字搜索" @keyup.enter.native="searchCyj" />
                      </el-form-item>
                      <el-form-item>
                        <el-button icon="el-icon-search" @click="searchCyj">查询</el-button>
                        <!-- <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel(1)">导出Excel</el-button> -->
                      </el-form-item>
                    </el-form>
                  </div>
                  <div v-loading="cyjLoading">
                    <el-table
                      :data="cyjData"
                      stripe
                      :row-style="{cursor: 'pointer'}"
                      style="width: 100%"
                      @row-click="openCyjDetails"
                    >
                      <el-table-column
                        label="冲业绩名称"
                        min-width="200"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span style="color:#000;">{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="审核人"
                        min-width="120"
                        align="center"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          {{ scope.row.auditname || '-' }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="审核时间"
                        min-width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.audittime || '-' }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="收款时间"
                        min-width="120"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.receipttime || '-' }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="余额去向"
                        min-width="150"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.info || '-' }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="冲业绩总额"
                        width="140"
                        fixed="right"
                        align="center"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span style="font-weight: 500;">{{ scope.row.amount }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="所剩余额"
                        width="130"
                        align="center"
                        fixed="right"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span style="color:#409EFF;font-weight: 500;">{{ scope.row.balance }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="120"
                        align="center"
                        fixed="right"
                        label="操作"
                      >
                        <template slot-scope="scope">
                          <el-button icon="el-icon-document" size="mini" @click.stop="viewCyjRecord(scope.row)">使用记录</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      v-if="cyjForm.total>0"
                      style="margin-top: 20px"
                      background
                      :current-page="cyjForm.currentPage"
                      :page-sizes="[10, 20, 30]"
                      :page-size="cyjForm.pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="cyjForm.total"
                      @size-change="handleSizeChangeCyj"
                      @current-change="handleCurrentChangeCyj"
                    />
                  </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="业绩/支票返点" name="second">
              <div class="card-content">
                <div style="margin-top: 10px;">
                  <el-form :inline="true" size="small" :model="rebateForm" @submit.native.prevent>
                    <el-form-item label="抵款方式">
                      <el-select v-model="rebateForm.credit" style="width: 120px" filterable clearable @keyup.enter.native="searchRebate">
                        <el-option label="限制冲抵" :value="0" />
                        <el-option label="任意冲抵" :value="9" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="使用状态">
                      <el-select v-model="rebateForm.type" style="width: 120px" filterable clearable @keyup.enter.native="searchRebate">
                        <el-option label="有效" :value="1" />
                        <el-option label="过期" :value="0" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="搜索关键字">
                      <el-input v-model="rebateForm.content" placeholder="关键字搜索" @keyup.enter.native="searchRebate" />
                    </el-form-item>
                    <el-form-item>
                      <el-button icon="el-icon-search" @click="searchRebate">查询</el-button>
                      <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel(0)">导出Excel</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-loading="rebateloading">
                  <el-table
                    :data="rebateData"
                    stripe
                    :row-style="{cursor: 'pointer'}"
                    style="width: 100%"
                    @row-click="openRebateDetails"
                  >
                    <el-table-column
                      label="返点名称"
                      min-width="200"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.ismeet===0" :disable-transitions="true" size="mini" type="warning">过期</el-tag>
                        <el-tag v-if="scope.row.ismeet===1" :disable-transitions="true" size="mini">有效</el-tag>
                        <span style="color:#000;margin-left: 6px;">{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="备注"
                      min-width="200"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="color:#000;margin-left: 6px;">{{ scope.row.remark }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="抵款方式"
                      width="140"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.credit===0">最高冲抵{{ scope.row.maximpact }}%</span>
                        <span v-if="scope.row.credit===1">享受{{ scope.row.maxdiscount }}折</span>
                        <span v-if="scope.row.credit===9">任意冲抵</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="有效期"
                      width="200"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.starttime==='0'">无期限</span>
                        <span v-if="scope.row.starttime!=='0'">{{ scope.row.starttime }} ~ {{ scope.row.endtime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审核人"
                      width="120"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.auditname }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审核时间"
                      width="180"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.audittime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="返点总额"
                      width="150"
                      align="center"
                      fixed="right"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="font-weight: 500;">{{ scope.row.amount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="所剩余额"
                      width="130"
                      align="center"
                      fixed="right"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="color:#409EFF;font-weight: 500;">{{ scope.row.balance }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="120"
                      align="center"
                      fixed="right"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button icon="el-icon-document" size="mini" @click.stop="viewRebateRecord(scope.row)">使用记录</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="rebateForm.total>0"
                    style="margin-top: 20px"
                    background
                    :current-page="rebateForm.currentPage"
                    :page-sizes="[10, 20, 30]"
                    :page-size="rebateForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="rebateForm.total"
                    @size-change="handleSizeChangeRebate"
                    @current-change="handleCurrentChangeRebate"
                  />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="售后赔款" name="third">
              <div class="card-content">
                <div style="margin-top: 10px;">
                  <el-form :inline="true" size="small" :model="afterForm" @submit.native.prevent>
                    <el-form-item label="抵款方式">
                      <el-select v-model="afterForm.credit" style="width: 120px" filterable clearable @keyup.enter.native="searchAfter">
                        <el-option label="限制冲抵" :value="0" />
                        <el-option label="任意冲抵" :value="9" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="搜索关键字">
                      <el-input v-model="afterForm.content" placeholder="关键字搜索" @keyup.enter.native="searchAfter" />
                    </el-form-item>
                    <el-form-item>
                      <el-button icon="el-icon-search" @click="searchAfter">查询</el-button>
                      <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel(1)">导出Excel</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-loading="afterLoading">
                  <el-table
                    :data="afterData"
                    stripe
                    :row-style="{cursor: 'pointer'}"
                    style="width: 100%"
                    @row-click="openAfterDetails"
                  >
                    <el-table-column
                      label="赔款名称"
                      min-width="200"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="color:#000;">{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="抵款方式"
                      width="140"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.credit===0">最高冲抵{{ scope.row.maximpact }}%</span>
                        <span v-if="scope.row.credit===9">任意冲抵</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审核人"
                      width="120"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.auditname }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审核时间"
                      width="180"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.audittime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="赔款总额"
                      width="150"
                      fixed="right"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="font-weight: 500;">{{ scope.row.amount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="所剩余额"
                      width="130"
                      align="center"
                      fixed="right"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="color:#409EFF;font-weight: 500;">{{ scope.row.balance }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="120"
                      align="center"
                      fixed="right"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button icon="el-icon-document" size="mini" @click.stop="viewAfterRecord(scope.row)">使用记录</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="afterForm.total>0"
                    style="margin-top: 20px"
                    background
                    :current-page="afterForm.currentPage"
                    :page-sizes="[10, 20, 30]"
                    :page-size="afterForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="afterForm.total"
                    @size-change="handleSizeChangeAfter"
                    @current-change="handleCurrentChangeAfter"
                  />
                </div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="报备金" name="fourth">
              <div class="card-content">
                <div style="margin-top: 10px;">
                  <el-form :inline="true" size="small" :model="reportForm" @submit.native.prevent>
                    <el-form-item label="使用状态">
                      <el-select v-model="reportForm.type" style="width: 120px" filterable clearable @keyup.enter.native="searchReport">
                        <el-option label="有效" :value="1" />
                        <el-option label="过期" :value="0" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="搜索关键字">
                      <el-input v-model="reportForm.content" placeholder="关键字搜索" @keyup.enter.native="searchReport" />
                    </el-form-item>
                    <el-form-item>
                      <el-button icon="el-icon-search" @click="searchReport">查询</el-button>
                      <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel(2)">导出Excel</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-loading="reportloading">
                  <el-table
                    :data="reportData"
                    stripe
                    :row-style="{cursor: 'pointer'}"
                    style="width: 100%"
                    @row-click="openReportDetails"
                  >
                    <el-table-column
                      label="报备金名称"
                      min-width="200"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <el-tag v-if="!scope.row.ischeck" :disable-transitions="true" size="mini" type="warning">已转货款</el-tag>
                        <el-tag v-if="scope.row.ischeck" :disable-transitions="true" size="mini">有效</el-tag>
                        <span style="color:#000;margin-left: 6px;">{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="有效期"
                      width="200"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.starttime }} ~ {{ scope.row.endtime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审核人"
                      width="120"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.auditname }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审核时间"
                      width="180"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.audittime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="报备订单"
                      width="150"
                      align="center"
                      fixed="right"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="font-weight: 500;margin-right:3px;color:#909399">{{ scope.row.num }}</span>/<span style="margin-left:3px;font-weight: 500;color:#409EFF;">{{ scope.row.ordercount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="报备总额"
                      width="150"
                      fixed="right"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="color:#99a9bf">报备总额：</span>
                        <span style="font-weight: 500;">{{ scope.row.amount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="所剩余额"
                      width="130"
                      align="center"
                      fixed="right"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span style="color:#409EFF;font-weight: 500;">{{ scope.row.balance }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="120"
                      fixed="right"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button icon="el-icon-document" size="mini" @click.stop="viewReportRecord(scope.row)">使用记录</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="reportForm.total>0"
                    style="margin-top: 20px"
                    background
                    :current-page="reportForm.currentPage"
                    :page-sizes="[10, 20, 30]"
                    :page-size="reportForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="reportForm.total"
                    @size-change="handleSizeChangeReport"
                    @current-change="handleCurrentChangeReport"
                  />
                </div>
              </div>
            </el-tab-pane> -->

            <!-- id：杭州-首造全屋智能的账户 -->
            <el-tab-pane v-if="id === '1137fdb9-88cd-4827-82a1-c256e83b84d6'" label="零售项目" name="project">
              <div class="card-content">
                <div style="margin-top: 10px;">
                  <el-form :inline="true" size="small" :model="projectForm" @submit.native.prevent>
                    <el-form-item label="搜索关键字">
                      <el-input v-model="projectForm.search" placeholder="关键字搜索" @keyup.enter.native="searchProject" />
                    </el-form-item>
                    <el-form-item>
                      <el-button icon="el-icon-search" @click="searchProject">查询</el-button>
                      <el-button icon="el-icon-plus" type="primary" @click="addProject">新增项目</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-loading="projectloading">
                  <el-table
                    :data="projectData"
                    stripe
                    style="width: 100%"
                  >
                    <el-table-column
                      label="项目名称"
                      prop="name"
                      min-width="200"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      label="项目信息"
                      prop="info"
                      min-width="400"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      label="总金额"
                      prop="amount"
                      align="center"
                      min-width="100"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <span style="color:#409EFF;font-weight: 500;">{{ scope.row.amount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="余额"
                      prop="balance"
                      align="center"
                      min-width="100"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <span style="color:#409EFF;font-weight: 500;">{{ scope.row.balance }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="220"
                      fixed="right"
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button icon="el-icon-money" size="mini" @click.stop="rechargeProject(scope.row)">充值</el-button>
                        <el-button icon="el-icon-document" size="mini" @click.stop="viewProjectRecord(scope.row)">资金记录</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="projectForm.total>0"
                    style="margin-top: 20px"
                    background
                    :current-page="projectForm.currentPage"
                    :page-sizes="[10, 20, 30]"
                    :page-size="projectForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="projectForm.total"
                    @size-change="handleSizeChangeProject"
                    @current-change="handleCurrentChangeProject"
                  />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <!-- 订单收款详细 -->
    <el-dialog
      title="订单收款详细"
      :visible.sync="collectRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="collectRecordLoading" class="tcf-detail-table">
        <tr>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td>{{ collectRecordData.time }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.productNum }}</td>
        </tr>
        <tr>
          <th>收款日期</th>
          <td>{{ collectRecordData.receipttime }}</td>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</td>
        </tr>
        <tr>
          <th>收款内容</th>
          <td>{{ collectRecordData.paycontent }}</td>
          <th>卡号</th>
          <td>{{ collectRecordData.type == 0 ? '账户余额抵扣' : (collectRecordData.type == 8 ? '样品预存款抵扣' : collectRecordData.card) }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="collectRecordVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="收款详细"
      :visible.sync="otherRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table class="tcf-detail-table">
        <tr>
         <!-- <th>操作人</th>
          <td>{{ otherRecordData.operName }}</td> -->
          <th>操作时间</th>
          <td colspan="3">{{ otherRecordData.time }}</td>
        </tr>
        <tr>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ otherRecordData.money }}</td>
          <th>卡号</th>
          <td>{{ otherRecordData.type == 0 ? '账户余额抵扣' : (otherRecordData.type == 8 ? '样品预存款抵扣' : otherRecordData.card) }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgReceiptApplySrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReceiptApplySrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ otherRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="otherRecordVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 收款申请详情 -->
    <el-dialog
      title="收款申请详情"
      :visible.sync="receiptApplyVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="receiptApplyLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ receiptApplyData.applyname }}</td>
          <th>申请时间</th>
          <td>{{ receiptApplyData.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ receiptApplyData.dealerName }}</td>
          <th>卡号</th>
          <td>{{ receiptApplyData.card }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">{{ receiptApplyData.accountname }}（{{ receiptApplyData.accountcard }}）</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ receiptApplyData.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ receiptApplyData.nature }}</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td colspan="3" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ receiptApplyData.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgReceiptApplySrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReceiptApplySrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ receiptApplyData.remark }}</td>
        </tr>
        <tr v-if="receiptApplyData.mark===2||receiptApplyData.mark===1">
          <th>审核人</th>
          <td>{{ receiptApplyData.auditname }}</td>
          <th>审核时间</th>
          <td>{{ receiptApplyData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="receiptApplyVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 报备金详情 -->
    <el-dialog
      title="报备金详情"
      :visible.sync="viewReportVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewReportLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewReportdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewReportdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewReportdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{ viewReportdata.per }}/单
          </td>
          <th>账户余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.balance }}</td>
          <td colspan="2">
            同比享受最低折扣不低于 {{ viewReportdata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress" :key="index">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
                <td>
                  <span v-if="d.orderid!==null&&d.orderid!==''&&d.orderid!==undefined" style="color:#409EFF;cursor: pointer" @click="goOrder(d.orderid)"><i class="el-icon-document" /> <span v-if="d.produnum===null||d.produnum===''||d.produnum===undefined">{{ d.ordernum }}</span><span v-if="d.produnum!==null&&d.produnum!==''&&d.produnum!==undefined">{{ d.produnum }}</span></span>
                  <el-tag v-if="d.orderid===null||d.orderid===''||d.orderid===undefined" :disable-transitions="true" size="mini" type="danger">未关联</el-tag>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date" /> {{ viewReportdata.starttime }} ~ {{ viewReportdata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount" :key="index">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewReportAcccount.groupname }}（{{ viewReportAcccount.name }}，{{ viewReportAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewReportdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewReportdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgReportSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReportSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr v-if="viewReportdata.mark===2">
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 业绩/支票返点详情 -->
    <el-dialog
      title="业绩/支票返点详情"
      :visible.sync="viewRebateVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewRebateLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewRebatedata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewRebatedata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewRebatedata.delname }}</td>
          <th>返点名称</th>
          <td colspan="3" style="color:#000;">{{ viewRebatedata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewRebatedata.starttime==='0'"><i class="el-icon-date" /> 无期限</span>
            <span v-if="viewRebatedata.starttime!=='0'"><i class="el-icon-date" /> {{ viewRebatedata.starttime }} ~ {{ viewRebatedata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.amount }}</td>
          <th>返点余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewRebatedata.credit===0">最高冲抵{{ viewRebatedata.maximpact }}%</span>
            <span v-if="viewRebatedata.credit===1">享受{{ viewRebatedata.maxdiscount }}折</span>
            <span v-if="viewRebatedata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewRebatedata.ordertype===0">无限制</span>
            <span v-if="viewRebatedata.ordertype===1">正单</span>
            <span v-if="viewRebatedata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{ viewRebatedata.orderMoney }} 元以上可享受，同比享受最低折扣不低于 {{ viewRebatedata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgRebateSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgRebateSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewRebatedata.remark }}</td>
        </tr>
        <tr v-if="viewRebatedata.mark===2">
          <th>审核人</th>
          <td>{{ viewRebatedata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewRebatedata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewRebateVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <el-dialog
      :title="receiptAccountTitle"
      :visible.sync="receiptAccountVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-table
        v-loading="receiptAccountLoading"
        :data="receiptAccountTableData"
        border
        height="400"
        size="small"
        style="width: 100%"
      >
        <el-table-column
          prop="time"
          align="center"
          label="使用时间"
          width="170"
        />
        <el-table-column
          prop="username"
          align="center"
          label="操作人"
          width="80"
        />
        <el-table-column
          width="100"
          align="center"
          label="生产单号"
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;font-weight: 500;">{{ scope.row.produnum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="使用类型"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.opertype===0" :disable-transitions="true" size="mini" type="warning">订单报价</el-tag>
            <el-tag v-if="scope.row.opertype===1" :disable-transitions="true" size="mini">订单收款</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="优惠折扣"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===2&&scope.row.opertype===0">{{ scope.row.discount }}</span>
            <span v-if="scope.row.type===2&&scope.row.opertype!==0">N/A</span>
            <span v-if="scope.row.type===0||scope.row.type===1||scope.row.type===5">N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="使用金额"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===0||scope.row.type===1||scope.row.type===5||(scope.row.type===2&&scope.row.opertype!==0)" style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
            <span v-if="scope.row.type===2&&scope.row.opertype===0">N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="收款内容"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.opertype!==0">{{ scope.row.paycontent }}</span>
            <span v-if="scope.row.type===2&&scope.row.opertype===0">报价优惠{{ scope.row.money }}元</span>
            <span v-if="scope.row.type===0&&scope.row.opertype===0">报价优惠</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="备注"
        >
          <template slot-scope="scope">
            <span style="font-weight: 500;">{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          align="center"
          fixed="right"
          label="订单号"
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;cursor: pointer" @click="goOrder(scope.row.orderid)"><i class="el-icon-document" /> {{ scope.row.ordernum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 售后赔款详情 -->
    <el-dialog
      title="售后赔款详情"
      :visible.sync="viewAfterVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewAfterLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewAfterdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewAfterdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewAfterdata.delname }}</td>
          <th>赔款名称</th>
          <td colspan="3" style="color:#000;">{{ viewAfterdata.name }}</td>
        </tr>
        <tr>
          <th>赔款总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.amount }}</td>
          <th>账户余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewAfterdata.credit===0">最高冲抵{{ viewAfterdata.maximpact }}%</span>
            <span v-if="viewAfterdata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewAfterdata.ordertype===0">无限制</span>
            <span v-if="viewAfterdata.ordertype===1">正单</span>
            <span v-if="viewAfterdata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{ viewAfterdata.orderMoney }} 元以上可冲抵
          </td>
        </tr>
        <tr>
          <th>赔款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgAfterSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgAfterSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewAfterdata.remark }}</td>
        </tr>
        <tr v-if="viewAfterdata.mark===2">
          <th>审核人</th>
          <td>{{ viewAfterdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewAfterdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewAfterVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 冲业绩详情 -->
    <el-dialog
      title="冲业绩详情"
      :visible.sync="viewCyjVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewCyjLoading" class="tcf-detail-table cyj-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewCyjdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewCyjdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewCyjdata.dealerName || dealerDetail.all_name }}</td>
          <th v-if="viewCyjdata.nature == '银行收款'">卡号</th>
          <td v-if="viewCyjdata.nature == '银行收款'">{{ viewCyjdata.card || '-' }}</td>
        </tr>
        <tr v-if="viewCyjdata.nature == '银行收款'">
          <th>打款账户</th>
          <td colspan="3">{{ viewCyjdata.aCardName }}（{{ viewCyjdata.aCard }}）</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ viewCyjdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewCyjdata.nature || '银行收款' }}</td>
        </tr>
        <tr>
          <th>冲业绩名称</th>
          <td colspan="5" style="color:#000;">{{ viewCyjdata.name }}</td>
        </tr>
        <tr>
          <th>冲业绩总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewCyjdata.amount }}</td>
          <th>所剩余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewCyjdata.balance }}</td>
        </tr>
        <tr v-if="viewCyjdata.nature == '银行收款'">
          <th>冲业绩凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgCyjSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgCyjSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>余额去向</th>
          <td colspan="5">{{ viewCyjdata.info || '-' }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ viewCyjdata.remark || '-' }}</td>
        </tr>
        <tr v-if="viewCyjdata.nature == '银行收款'">
          <th>审核人</th>
          <td>{{ viewCyjdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewCyjdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewCyjVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="样品预存款收款详情"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="fullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ eidtList.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ eidtList.time }}</td>
        </tr>
        <tr>
          <th>店面形式</th>
          <td>{{ eidtList.shopform===1?'店中店':eidtList.shopform===2?'沿街店':'商场内店' }}</td>
          <th>门店地址</th>
          <td>{{ eidtList.address }}</td>
        </tr>
        <tr>
          <th>总面积</th>
          <td>{{ eidtList.totalarea }}</td>
          <th>本品牌占店面积</th>
          <td>{{ eidtList.area }}</td>
        </tr>
        <tr>
          <th>客户</th>
          <td><el-button type="text" size="small" icon="el-icon-s-custom">{{ eidtList.all_name }}</el-button></td>
          <th>卡号</th>
          <td>{{ eidtList.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">
            {{ eidtList.accountname }}（{{ eidtList.accountcard }}）
            <!-- <span v-for="av in eidtList.accountVoList" v-if="av.is_select===1">{{ av.account_name }}（{{ av.card }}）</span> -->
          </td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ eidtList.pay_time }}</td>
          <th>打款金额</th>
          <td>{{ eidtList.pay_price }}（样品预存款：{{ eidtList.joins }}，加盟费：{{ eidtList.insure }}）</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ eidtList.remark }}</td>
        </tr>
        <tr v-if="eidtList.joinType===0 && (eidtList.mark===1||eidtList.mark===2||eidtList.mark===4||eidtList.mark===9)">
          <th>招商总监</th>
          <td>{{ eidtList.dirname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ eidtList.dirtime }}</td>
        </tr>
        <tr v-if="eidtList.mark===2||eidtList.mark===4||eidtList.mark===9 || (eidtList.joinType===1 && eidtList.mark>0)">
          <th>财务审核</th>
          <td>{{ eidtList.auditname }}</td>
          <th>审核时间</th>
          <td>{{ eidtList.audittime }}</td>
        </tr>
        <tr v-if="eidtList.mark===4 || (eidtList.joinType===1 && eidtList.mark===1)">
          <th>财务驳回原因</th>
          <td colspan="3" style="color:#f56c6c">{{ eidtList.rson }}</td>
        </tr>
        <tr v-if="((eidtList.joinType===0&&eidtList.mark===1) || (eidtList.joinType===1&&eidtList.mark===0)) && eidtList.rson">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ eidtList.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <el-dialog
      :title="qhwlTitle"
      :visible.sync="qhwlVisible"
      width="50%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="qhwlForm" v-loading="qhwlLoading" style="padding: 0 20px" :model="qhwlForm" label-width="80px" size="small">
        <div>
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ qhwlForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">经销商：</span>
          <span>{{ qhwlForm.delinfo }}</span>
          <span style="color:#99a9bf;margin-left:30px">总价：</span>
          <span style="font-weight: 500;color:#409EFF">{{ qhwlForm.addprice }}</span>
        </div>
        <div style="margin:10px 0">
          <span style="color:#99a9bf;">增加备注：</span>
          <span v-if="qhwlForm.remark!==null&&qhwlForm.remark!==''&&qhwlForm.remark!==undefined">{{ qhwlForm.remark }}</span>
          <span v-if="qhwlForm.remark===null||qhwlForm.remark===''||qhwlForm.remark===undefined">N/A</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="qhwlMaterialList"
          size="small"
          border
          row-key="material_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          tooltip-effect="dark"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          />
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          />
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          />
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          />
          <el-table-column
            align="center"
            label="标配数量"
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_standard===1">{{ scope.row.standard }}</span>
              <el-tag v-if="scope.row.is_standard!==1" :disable-transitions="true" type="info" size="mini">非标配</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="price"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          />
          <el-table-column
            label="价格/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.addprice>0" style="font-weight: 500;color:#409EFF">{{ scope.row.addprice }}</span>
              <span v-if="scope.row.addprice<=0" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.counts }}</span>
            </template>
          </el-table-column>
        </el-table>
        <table class="tcf-detail-table" style="margin-bottom: 20px">
          <tr>
            <th>收款内容</th>
            <td>{{ qhwlForm.datainfo.paycontent }}</td>
            <th>收款日期</th>
            <td>{{ qhwlForm.datainfo.receipttime }}</td>
            <th>收款金额</th>
            <td style="font-weight: 500;color:#409EFF">{{ qhwlForm.datainfo.money }}</td>
          </tr>
          <tr>
            <th>卡号</th>
            <td>{{ qhwlForm.datainfo.card }}</td>
            <th>操作人</th>
            <td>{{ qhwlForm.datainfo.operName }}</td>
            <th>操作时间</th>
            <td>{{ qhwlForm.datainfo.time }}</td>
          </tr>
          <tr>
            <th>备注</th>
            <td colspan="5">{{ qhwlForm.datainfo.remark }}</td>
          </tr>
        </table>
      </el-form>
    </el-dialog>

    <!-- 新增项目 -->
    <el-dialog
      title="新增零售项目"
      :visible.sync="projectVisible"
      width="500px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="projectForm" v-loading="projectloading" :model="projectForm" :rules="projectRules" label-position="right" label-width="80px">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="projectForm.name" maxlength="100" placeholder="请输入项目名称" show-word-limit />
        </el-form-item>
        <el-form-item label="项目信息" prop="info">
          <el-input v-model="projectForm.info" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="projectloading" @click="submitProject('projectForm')">立即提交</el-button>
          <el-button @click="projectVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 项目充值 -->
    <el-dialog
      title="零售项目充值"
      :visible.sync="rechargeProjectVisible"
      width="500px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="rechargeProjectForm" v-loading="rechargeProjectLoading" :model="rechargeProjectForm" :rules="rechargeProjectRules" label-position="right" label-width="90px" size="small">
        <!-- <el-form-item label="经销商" prop="delid">
          <el-input v-model="rechargeProjectForm.dealerName" :disabled="true" />
        </el-form-item> -->
        <el-form-item label="打款账户" prop="aid">
          <el-select v-model="rechargeProjectForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receiptTime">
          <el-date-picker
            v-model="rechargeProjectForm.receiptTime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="打款金额" prop="amount">
          <el-input v-model="rechargeProjectForm.amount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="rechargeProjectForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg key="imgRecharge" v-model="rechargeProjectForm.imgids" :limit="9" :size="'sm'" :old="rechargeProjectImgList" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="rechargeProjectForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="rechargeProjectLoading" @click="submitRecharge('rechargeProjectForm')">立即提交</el-button>
          <el-button @click="rechargeProjectVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 项目资金记录 -->
    <el-dialog
      title="项目资金记录"
      :visible.sync="projectApplyVisible"
      width="70%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form :inline="true" size="small" :model="projectApplyForm" @submit.native.prevent>
        <el-form-item label="搜索关键字">
          <el-input v-model="projectApplyForm.search" placeholder="关键字搜索" @keyup.enter.native="searchProjectApply" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="searchProjectApply">查询</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="projectApplyLoading">
        <!-- <table v-loading="projectApplLoading" class="tcf-detail-table">
          <tr>
            <th>收款日期</th>
            <td>{{ collectRecordData.receipttime }}</td>
            <th>收款金额</th>
            <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</td>
          </tr>
        </table> -->
        <el-table
          :data="projectApplyList"
          stripe
          style="width: 100%"
        >
          <el-table-column
            label="类型"
            prop="type"
            align="center"
            width="90"
            fixed="left"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.type==0" :disable-transitions="true" size="mini" type="success">充值</el-tag>
              <el-tag v-if="scope.row.type==1" :disable-transitions="true" size="mini" type="danger">订单抵扣</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="使用订单"
            prop="ordernum"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.ordernum" style="font-weight: 500;color:#409EFF">{{ scope.row.ordernum }}</span>
              <span v-else style="color:#99a9bf">N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            label="打款日期"
            prop="receipttime"
            align="center"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="申请人"
            prop="username"
            align="center"
            min-width="90"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="申请时间"
            prop="applytime"
            align="center"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="审核时间"
            prop="audittime"
            align="center"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="金额"
            prop="amount"
            align="center"
            width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0" style="color:#67C23A;font-weight: 500;">+ {{ scope.row.amount }}</span>
              <span v-else style="color:#F56C6C;font-weight: 500;">- {{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="审核状态"
            prop="mark"
            align="center"
            width="80"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="warning">待审核</el-tag>
              <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="danger">已拒绝</el-tag>
              <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已通过</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="projectApplyForm.total>0"
          style="margin-top: 20px"
          background
          :current-page="projectApplyForm.currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="projectApplyForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="projectApplyForm.total"
          @size-change="handleSizeChangeProjectApply"
          @current-change="handleCurrentChangeProjectApply"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="projectApplyVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAccountReceipt, getDealerJoinUse } from '@/api/dealer'
import { getMaterialApplyDetail, getCollectRecordMaterialsByCrmid } from '@/api/work'
import { getMerchantsMoneyDetail } from '@/api/work'
// import ClientInfo from '@/components/ClientInfo'
import {
  getDealerAccountDataByStaff, getCollectRecordByCrid, getReceiptApplyByRaid, getDealerAccountReportById, getDealerAccountRebateList,
  getDealerAccountRebateById, getDealerReceiptAccountList, getDealerAccountAfterList, getDealerAccountAfterById, getDealerAccountReportList, getDealerAchievementList,
  getDealerJoinApplyById, exportDealerAccountRebateExcel, exportDealerAfterAccountExcel, exportDealerReportAccountExcel,
  getProjects, addOrEditProject, getProjectApplys, addOrEditProjectApply
} from '@/api/erp'
import { getAccounts, getGroupReport } from '@/api/pub'

import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'AccountDetail',
  components: {
    MultiImg
  },
  data() {
    return {
      btnLoading: false,
      activeName: 'first',
      id: '',
      accountLoading: false,
      accountData: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      receiptForm: {
        type: null,
        asstype: null,
        content: '',
        time: [],
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      joinForm: {
        content: '',
        time: [],
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      joinloading: false,
      receiptloading: false,
      receiptData: [],
      joinData: [],
      dealerDetail: {},
      collectRecordVisible: false,
      collectRecordLoading: false,
      collectRecordData: [],
      otherRecordVisible: false,
      otherRecordLoading: false,
      otherRecordData: {},
      receiptApplyVisible: false,
      receiptApplyLoading: false,
      receiptApplyData: [],
      imgReceiptApplySrcList: [],
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      viewRebateVisible: false,
      viewRebateLoading: false,
      viewRebatedata: [],
      imgRebateSrcList: [],
      viewAfterVisible: false,
      viewAfterLoading: false,
      imgAfterSrcList: [],
      viewAfterdata: [],
      rebateForm: {
        credit: null,
        type: null,
        content: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      rebateloading: true,
      rebateData: [],
      receiptAccountTitle: '',
      receiptAccountVisible: false,
      receiptAccountLoading: false,
      receiptAccountTableData: [],
      receiptAccountType: 0,
      receiptAccountDataid: null,
      afterForm: {
        credit: null,
        content: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      afterLoading: true,
      afterData: [],

      viewCyjVisible: false,
      viewCyjLoading: false,
      imgCyjSrcList: [],
      viewCyjdata: [],
      cyjForm: {
        credit: null,
        content: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      cyjLoading: true,
      cyjData: [],

      reportForm: {
        type: null,
        content: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      reportloading: true,
      reportData: [],

      projectVisible: false,
      projectForm: {
        name: '',
        info: '',
        search: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      projectRules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
      },
      projectloading: true,
      projectData: [],

      rechargeProjectVisible: false,
      rechargeProjectLoading: false,
      rechargeProjectForm: {
        retailId: null,
        aid: null,
        receiptTime: '',
        amount: null,
        card: '',
        remark: '',
        imgids: []
      },
      rechargeProjectRules: {
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receiptTime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        amount: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        // card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
      rechargeProjectImgList: [],

      projectApplyForm: {
        search: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      projectTitle: '',
      projectApplyVisible: false,
      projectApplyLoading: false,
      projectApplyList: [],
      projectId: '',

      groupList: [],
      accountsList: [],

      qhwlTitle: '',
      qhwlVisible: false,
      qhwlLoading: false,
      qhwlForm: {
        manum: '',
        delinfo: '',
        addprice: '',
        remark: '',
        datainfo: []
      },
      qhwlMaterialList: [],
      fullscreenLoading: false,
      editVisible: false,
      eidtList: [],
      imgSrcList: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.id = this.$route.params && this.$route.params.id
    this.accountLoading = true
    getDealerAccountDataByStaff({ delid: this.id, groupid: this.user.dGroupid }).then(response => {
      this.dealerDetail = response.data
      this.accountData.push({
        accountname: this.dealerDetail.accountname,
        balance: this.dealerDetail.balance,
        achievement_balance: this.dealerDetail.achievement_balance,
        rebate_balance: this.dealerDetail.rebate_balance,
        after_balance: this.dealerDetail.after_balance,
        report_balance: this.dealerDetail.report_balance,
        inmon: this.dealerDetail.inmon,
        leftJoin: this.dealerDetail.leftJoin,
        joinn: this.dealerDetail.joinn,
        insure: this.dealerDetail.insure
      })
      this.setPageTitle()
      this.setTagsViewTitle()
      this.getAccountReceipt()
      this.getJoinUse()
      this.getAccountRebate()
      this.getAccountAfter()
      this.getAccountCyj()
      this.getAccountReport()
      this.getAccountProject()
      this.accountLoading = false
    }).catch(() => {
      this.accountLoading = false
    })

    getGroupReport().then(response => {
      this.groupList = response.data
      // .filter(i => i.groupid === this.user.dGroupid)
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
  },
  methods: {
    setTagsViewTitle() {
      const route = Object.assign({}, this.tempRoute, { title: `${this.dealerDetail.all_name}的账户` })
      this.$store.dispatch('tagsView/updateVisitedView', route)
    },
    setPageTitle() {
      document.title = `${this.dealerDetail.all_name}的账户`
    },
    searchReceipt() {
      if (this.receiptForm.content !== null && this.receiptForm.content.trim() !== '') {
        this.receiptForm.currentPage = 1
        this.getAccountReceipt()
      } else {
        this.receiptForm.content = ''
        this.receiptForm.currentPage = 1
        this.getAccountReceipt()
      }
    },
    searchJoin() {
      if (this.joinForm.content !== null && this.joinForm.content.trim() !== '') {
        this.joinForm.currentPage = 1
        this.getJoinUse()
      } else {
        this.joinForm.content = ''
        this.joinForm.currentPage = 1
        this.getJoinUse()
      }
    },
    searchRebate() {
      if (this.rebateForm.content !== null && this.rebateForm.content.trim() !== '') {
        this.rebateForm.currentPage = 1
        this.getAccountRebate()
      } else {
        this.rebateForm.content = ''
        this.rebateForm.currentPage = 1
        this.getAccountRebate()
      }
    },
    searchAfter() {
      if (this.afterForm.content !== null && this.afterForm.content.trim() !== '') {
        this.afterForm.currentPage = 1
        this.getAccountAfter()
      } else {
        this.afterForm.content = ''
        this.afterForm.currentPage = 1
        this.getAccountAfter()
      }
    },
    // 冲业绩
    searchCyj() {
      if (this.cyjForm.content !== null && this.cyjForm.content.trim() !== '') {
        this.cyjForm.currentPage = 1
        this.getAccountCyj()
      } else {
        this.cyjForm.content = ''
        this.cyjForm.currentPage = 1
        this.getAccountCyj()
      }
    },
    searchReport() {
      if (this.reportForm.content !== null && this.reportForm.content.trim() !== '') {
        this.reportForm.currentPage = 1
        this.getAccountReport()
      } else {
        this.reportForm.content = ''
        this.reportForm.currentPage = 1
        this.getAccountReport()
      }
    },
    // 项目查询
    searchProject() {
      if (this.projectForm.search !== null && this.projectForm.search.trim() !== '') {
        this.projectForm.currentPage = 1
        this.getAccountProject()
      } else {
        this.projectForm.search = ''
        this.projectForm.currentPage = 1
        this.getAccountProject()
      }
    },
    // 项目资金记录查询
    searchProjectApply() {
      if (this.projectApplyForm.search !== null && this.projectApplyForm.search.trim() !== '') {
        this.projectApplyForm.currentPage = 1
        this.getProjectApply()
      } else {
        this.projectApplyForm.search = ''
        this.projectApplyForm.currentPage = 1
        this.getProjectApply()
      }
    },
    handleSizeChangeProject(val) {
      this.receiptForm.pageSize = val
      this.getAccountProject()
    },
    handleCurrentChangeProject(val) {
      this.receiptForm.currentPage = val
      this.getAccountProject()
    },
    handleSizeChangeProjectApply(val) {
      this.receiptForm.pageSize = val
      this.getProjectApply()
    },
    handleCurrentChangeProjectApply(val) {
      this.receiptForm.currentPage = val
      this.getProjectApply()
    },
    handleSizeChangeReceipt(val) {
      this.receiptForm.pageSize = val
      this.getAccountReceipt()
    },
    handleCurrentChangeReceipt(val) {
      this.receiptForm.currentPage = val
      this.getAccountReceipt()
    },
    handleSizeChangeJoin(val) {
      this.joinForm.pageSize = val
      this.getJoinUse()
    },
    handleCurrentChangeJoin(val) {
      this.joinForm.currentPage = val
      this.getJoinUse()
    },
    handleSizeChangeRebate(val) {
      this.rebateForm.pageSize = val
      this.getAccountRebate()
    },
    handleCurrentChangeRebate(val) {
      this.rebateForm.currentPage = val
      this.getAccountRebate()
    },
    handleSizeChangeAfter(val) {
      this.afterForm.pageSize = val
      this.getAccountAfter()
    },
    handleCurrentChangeAfter(val) {
      this.afterForm.currentPage = val
      this.getAccountAfter()
    },

    handleSizeChangeCyj(val) {
      this.cyjForm.pageSize = val
      this.getAccountCyj()
    },
    handleCurrentChangeCyj(val) {
      this.cyjForm.currentPage = val
      this.getAccountCyj()
    },

    handleSizeChangeReport(val) {
      this.reportForm.pageSize = val
      this.getAccountAfter()
    },
    handleCurrentChangeReport(val) {
      this.reportForm.currentPage = val
      this.getAccountAfter()
    },
    // 获取经销商样品预存款抵扣信息
    getJoinUse() {
      this.joinloading = true
      let starttime = ''
      let endtime = ''
      if (this.joinForm.time !== null && this.joinForm.time !== undefined) {
        if (this.joinForm.time.length === 2) {
          starttime = this.joinForm.time[0]
          endtime = this.joinForm.time[1]
        }
      }
      const data = {
        delid: this.dealerDetail.dealer_id,
        content: this.joinForm.content,
        page: this.joinForm.currentPage,
        limit: this.joinForm.pageSize,
        starttime: starttime,
        endtime: endtime
      }
      getDealerJoinUse(data).then(response => {
        this.joinData = response.data
        this.joinForm.total = response.total
        this.joinloading = false
      }).catch(() => {
        this.joinloading = false
      })
    },
    getAccountReceipt() {
      this.receiptloading = true
      let starttime = ''
      let endtime = ''
      if (this.receiptForm.time !== null && this.receiptForm.time !== undefined) {
        if (this.receiptForm.time.length === 2) {
          starttime = this.receiptForm.time[0]
          endtime = this.receiptForm.time[1]
        }
      }
      const data = {
        accid: this.dealerDetail.accid,
        content: this.receiptForm.content,
        type: this.receiptForm.type,
        page: this.receiptForm.currentPage,
        limit: this.receiptForm.pageSize,
        starttime: starttime,
        endtime: endtime,
        asstype: this.receiptForm.asstype
      }
      getDealerAccountReceipt(data).then(response => {
        this.receiptData = response.data
        this.receiptForm.total = response.total
        this.receiptloading = false
      }).catch(() => {
        this.receiptloading = false
      })
    },
    getAccountRebate() {
      this.rebateloading = true
      const data = {
        content: this.rebateForm.content,
        page: this.rebateForm.currentPage,
        limit: this.rebateForm.pageSize,
        delid: this.dealerDetail.dealer_id,
        groupid: this.user.dGroupid,
        credit: this.rebateForm.credit,
        type: this.rebateForm.type
      }
      getDealerAccountRebateList(data).then(response => {
        this.rebateData = response.data
        this.rebateForm.total = response.total
        this.rebateloading = false
      }).catch(() => {
        this.rebateloading = false
      })
    },
    getAccountAfter() {
      this.afterLoading = true
      const data = {
        content: this.afterForm.content,
        page: this.afterForm.currentPage,
        limit: this.afterForm.pageSize,
        delid: this.dealerDetail.dealer_id,
        groupid: this.user.dGroupid,
        credit: this.afterForm.credit
      }
      getDealerAccountAfterList(data).then(response => {
        this.afterData = response.data
        this.afterForm.total = response.total
        this.afterLoading = false
      }).catch(() => {
        this.afterLoading = false
      })
    },
    // 冲业绩账户
    getAccountCyj() {
      this.cyjLoading = true
      const data = {
        content: this.cyjForm.content,
        page: this.cyjForm.currentPage,
        limit: this.cyjForm.pageSize,
        delid: this.dealerDetail.dealer_id,
        groupid: this.user.dGroupid,
        credit: this.cyjForm.credit
      }
      getDealerAchievementList(data).then(response => {
        this.cyjData = response.data
        this.cyjForm.total = response.total
        this.cyjLoading = false
      }).catch(() => {
        this.cyjLoading = false
      })
    },
    getAccountReport() {
      this.reportloading = true
      const data = {
        content: this.reportForm.content,
        page: this.reportForm.currentPage,
        limit: this.reportForm.pageSize,
        delid: this.dealerDetail.dealer_id,
        groupid: this.user.dGroupid,
        type: this.reportForm.type
      }
      getDealerAccountReportList(data).then(response => {
        this.reportData = response.data
        this.reportForm.total = response.total
        this.reportloading = false
      }).catch(() => {
        this.reportloading = false
      })
    },
    // 项目资金
    getAccountProject() {
      this.projectloading = true
      const data = {
        search: this.projectForm.search,
        page: this.projectForm.currentPage,
        limit: this.projectForm.pageSize,
        dealerId: this.dealerDetail.dealer_id,
        userId: this.user.dUserid,
        groupId: this.user.dGroupid
      }
      getProjects(data).then(response => {
        this.projectData = response.data || []
        this.projectForm.total = response.total || 0
        this.projectloading = false
      }).catch(() => {
        this.projectloading = false
      })
    },
    goOrder(orderid) {
      this.collectRecordVisible = false
      this.receiptAccountVisible = false
      this.viewReportVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    openReceiptDetails(row) {
      if (row.asstype === 0) {
        return false
      }
      if (row.asstype === 8) {
        this.otherRecordVisible = true
        this.otherRecordData = { ...row }
        this.imgReceiptApplySrcList = []
        const imgs = []
        for (const c of row.imglst) {
          imgs.push(c.img_url)
        }
        this.imgReceiptApplySrcList = imgs
        return false
      }
      if (row.asstype === 1) {
        if (row.crid !== null && row.crid !== '' && row.crid !== undefined && row.crid !== 0) {
          this.collectRecordVisible = true
          this.collectRecordLoading = true
          getCollectRecordByCrid({ crid: row.crid }).then(response => {
            this.collectRecordData = response.data
            this.collectRecordLoading = false
          }).catch(() => {
            this.collectRecordData = []
            this.collectRecordLoading = false
          })
        } else {
          // 历史上没有关联收款的
          this.$router.push({ path: '/work/order/' + row.orderid })
        }
      }
      if (row.asstype === 2) {
        if (row.maid !== null && row.maid !== '' && row.maid !== undefined) {
          this.qhwlTitle = '物料申请单收款详情'
          this.qhwlMaterialList = []
          this.qhwlForm.remark = ''
          this.qhwlLoading = true
          getMaterialApplyDetail({ applyid: row.maid }).then(response => {
            const datalist = []
            for (const m of response.data.materialList) {
              if (m.ischeck) {
                if (response.data.materialsApply.isnewbus === 1) {
                  let count = m.counts
                  if (m.is_standard === 1) {
                    count = count - m.standard
                    if (count < 0) {
                      count = 0
                    }
                  }
                  m.addprice = (m.price * count).toFixed(2)
                } else {
                  m.addprice = (m.price * m.counts).toFixed(2)
                }
                if (m.children && m.children.length > 0) {
                  const children = []
                  let reduce_count = 0
                  m.children.forEach(child => {
                    if (child.ischeck) {
                      if (response.data.materialsApply.isnewbus === 1) {
                        let count = child.counts
                        if (child.is_standard === 1) {
                          reduce_count += child.counts
                          count = reduce_count - m.standard
                          if (count < 0) count = 0
                          if (count > child.counts) count = child.counts
                        }
                        child.addprice = (child.price * count).toFixed(2)
                      } else {
                        child.addprice = (child.price * child.counts).toFixed(2)
                      }
                      children.push(child)
                    } else {
                      child.addprice = 0
                    }
                  })
                  m.children = children
                }
                datalist.push(m)
              }
            }
            this.qhwlMaterialList = datalist
            this.qhwlForm.remark = response.data.materialsApply.remark
            this.qhwlForm.manum = response.data.materialsApply.manum
            this.qhwlForm.addprice = response.data.materialsApply.addprice
            this.qhwlForm.delinfo = response.data.materialsApply.delname
            getCollectRecordMaterialsByCrmid({ crmid: row.crmid }).then(response => {
              this.qhwlForm.datainfo = response.data
            })
            this.qhwlLoading = false
          }).catch(() => {
            this.qhwlLoading = false
          })
          this.qhwlVisible = true
        } else {
          return false
        }
      } else if (row.asstype === 3) {
        this.imgReceiptApplySrcList = []
        this.receiptApplyVisible = true
        this.receiptApplyLoading = true
        getReceiptApplyByRaid({ raid: row.raid }).then(response => {
          this.receiptApplyLoading = false
          this.receiptApplyData = response.data
          const imgs = []
          for (const c of this.receiptApplyData.imglst) {
            imgs.push(c.img_url)
          }
          this.imgReceiptApplySrcList = imgs
        }).catch(() => {
          this.receiptApplyData = []
          this.receiptApplyLoading = false
        })
      } else if (row.asstype === 4) {
        return false
      } else if (row.asstype === 5) {
        this.openReportDetails(row)
      }
    },
    openJoinDetails(row) {
      if (row.crid && row.crid !== 0) {
        this.collectRecordVisible = true
        this.collectRecordLoading = true
        getCollectRecordByCrid({ crid: row.crid }).then(response => {
          this.collectRecordData = response.data
          this.collectRecordLoading = false
        }).catch(() => {
          this.collectRecordData = []
          this.collectRecordLoading = false
        })
      } else if (row.paycontent === '样品预存款') {
        this.imgSrcList = []
        this.editVisible = true
        this.fullscreenLoading = true
        getMerchantsMoneyDetail({ payid: row.address, userid: this.user.dUserid }).then(response => {
          this.fullscreenLoading = false
          this.eidtList = response.data
          const imgs = []
          for (const c of this.eidtList.imgList) {
            imgs.push(c.img_url)
          }
          this.imgSrcList = imgs
        }).catch(() => {
          this.fullscreenLoading = false
        })
      } else if (row.paycontent === '样品预存款申请') {
        this.imgSrcList = []
        this.editVisible = true
        this.fullscreenLoading = true
        getDealerJoinApplyById({
          djaid: row.address,
          userid: this.user.dUserid
        }).then(response => {
          this.eidtList = response.data
          const imgs = []
          for (const c of this.eidtList.imgList) {
            imgs.push(c.img_url)
          }
          this.imgSrcList = imgs
          this.fullscreenLoading = false
        }).catch(() => {
          this.fullscreenLoading = false
        })
      } else {
        this.$router.push({ path: '/work/order/' + row.orderid })
      }
    },
    openRebateDetails(row) {
      this.imgRebateSrcList = []
      this.viewRebateVisible = true
      this.viewRebateLoading = true
      getDealerAccountRebateById({ darid: row.darid }).then(response => {
        this.viewRebateLoading = false
        this.viewRebatedata = response.data.dar
        const imgs = []
        for (const c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgRebateSrcList = imgs
      }).catch(() => {
        this.viewRebateLoading = false
      })
    },
    openAfterDetails(row) {
      this.imgAfterSrcList = []
      this.viewAfterVisible = true
      this.viewAfterLoading = true
      getDealerAccountAfterById({ daaid: row.daaid }).then(response => {
        this.viewAfterLoading = false
        this.viewAfterdata = response.data.daa
        const imgs = []
        for (const c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgAfterSrcList = imgs
      }).catch(() => {
        this.viewAfterLoading = false
      })
    },
    // 冲业绩详情
    openCyjDetails(row) {
      this.imgCyjSrcList = []
      this.viewCyjVisible = true
      this.viewCyjLoading = false
      this.viewCyjdata = { ...row }
      let imgs = []
      if (row.imgs && row.imgs.length > 0) {
        row.imgs.forEach(r => {
          imgs.push(r.img_url)
        });
      } else {
        imgs = [row.img]
      }
      this.imgCyjSrcList = imgs
    },
    openReportDetails(row) {
      this.imgReportSrcList = []
      this.viewReportVisible = true
      this.viewReportLoading = true
      getDealerAccountReportById({ darid: row.darid }).then(response => {
        this.viewReportLoading = false
        this.viewReportdata = response.data.dar
        this.viewReportAddress = response.data.daralst
        this.viewReportDiscount = response.data.dardlst
        this.viewReportAcccount = response.data.acccount
        const imgs = []
        for (const c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgReportSrcList = imgs
      }).catch(() => {
        this.viewReportLoading = false
      })
    },
    viewRebateRecord(row) {
      this.receiptAccountTitle = row.name
      this.receiptAccountType = 0
      this.receiptAccountDataid = row.darid
      this.getDealerReceiptAccount()
    },
    viewAfterRecord(row) {
      this.receiptAccountTitle = row.name
      this.receiptAccountType = 1
      this.receiptAccountDataid = row.daaid
      this.getDealerReceiptAccount()
    },
    viewReportRecord(row) {
      this.receiptAccountTitle = row.name
      this.receiptAccountType = 2
      this.receiptAccountDataid = row.darid
      this.getDealerReceiptAccount()
    },
    // 冲业绩记录
    viewCyjRecord(row) {
      this.receiptAccountTitle = row.name
      this.receiptAccountType = 5
      this.receiptAccountDataid = row.daaid
      this.getDealerReceiptAccount()
    },
    getDealerReceiptAccount() {
      this.receiptAccountVisible = true
      this.receiptAccountLoading = true
      const data = {
        type: this.receiptAccountType,
        dataid: this.receiptAccountDataid
      }
      getDealerReceiptAccountList(data).then(response => {
        this.receiptAccountTableData = response.data
        this.receiptAccountLoading = false
      }).catch(() => {
        this.receiptAccountLoading = false
      })
    },
    // 零售项目资金使用记录
    viewProjectRecord(row) {
      this.projectTitle = row.name
      this.projectId = row.id
      this.getProjectApply()
    },
    getProjectApply() {
      this.projectApplyVisible = true
      this.projectApplyLoading = true
      const data = {
        retailId: this.projectId,
        page: this.projectApplyForm.currentPage,
        limit: this.projectApplyForm.pageSize,
        search: this.projectApplyForm.search,
      }
      getProjectApplys(data).then(response => {
        this.projectApplyList = response.data || []
        this.projectApplyForm.total = response.total || 0
        this.projectApplyLoading = false
      }).catch(() => {
        this.projectApplyLoading = false
      })
    },

    // 新增项目
    addProject() {
      this.projectForm.name = ''
      this.projectForm.info = ''
      this.projectVisible = true
    },

    // 项目提交
    submitProject(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)return false;
        if (this.projectloading) return false;
        this.projectloading = true
        const data = {
          groupId: this.user.dGroupid,
          userId:this.user.dUserid,
          dealerId: this.id,
          retailId: this.projectForm.retailId,
          name: this.projectForm.name,
          info: this.projectForm.info,
        }
        addOrEditProject(data).then(response => {
          this.$message({
            message: '零售项目提交成功',
            type: 'success'
          })
          this.projectForm.name = ''
          this.projectForm.info = ''
          this.projectVisible = false
          this.projectloading = false
          this.getAccountProject()
        }).catch(() => {
          this.projectloading = false
        })
      })
    },

    // 项目充值
    rechargeProject(row) {
      this.rechargeProjectVisible = true
      this.rechargeProjectForm = {
        retailId: row.id,
        aid: null,
        receiptTime: '',
        amount: null,
        card: '',
        remark: '',
        imgids: []
      }
    },
    submitRecharge(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.rechargeProjectLoading) {
            this.rechargeProjectLoading = true
            const data = {
              userId: this.user.dUserid,
              applyId: 0,
              retailId: this.rechargeProjectForm.retailId,
              aid: this.rechargeProjectForm.aid,
              receiptTime: this.rechargeProjectForm.receiptTime,
              amount: this.rechargeProjectForm.amount,
              card: this.rechargeProjectForm.card,
              img: this.rechargeProjectForm.imgids.join(','),
              remark: this.rechargeProjectForm.remark,
              paycontent: '零售项目充值'
            }
            addOrEditProjectApply(data).then(response => {
              this.$message({
                message: '打款申请提交成功',
                type: 'success'
              })
              this.rechargeProjectForm = {}
              this.rechargeProjectVisible = false
              this.rechargeProjectLoading = false
              this.rechargeProjectImgList = []
              this.getProjects()
            }).catch(() => {
              this.rechargeProjectLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },

    exportExcel(type) {
      this.btnLoading = true
      if (type === 0) {
        const data = {
          content: this.rebateForm.content,
          credit: this.rebateForm.credit,
          type: this.rebateForm.type,
          delid: this.id,
          groupid: this.user.dGroupid
        }
        exportDealerAccountRebateExcel(data).then(response => {
          this.downLoad(response.data)
        }).catch(() => {
          this.btnLoading = false
        })
      } else if (type === 1) {
        const data = {
          content: this.afterForm.content,
          credit: this.afterForm.credit,
          delid: this.id,
          groupid: this.user.dGroupid
        }
        exportDealerAfterAccountExcel(data).then(response => {
          this.downLoad(response.data)
        }).catch(() => {
          this.btnLoading = false
        })
      } else if (type === 2) {
        const data = {
          content: this.reportForm.content,
          type: this.reportForm.type,
          delid: this.id,
          groupid: this.user.dGroupid
        }
        exportDealerReportAccountExcel(data).then(response => {
          this.downLoad(response.data)
        }).catch(() => {
          this.btnLoading = false
        })
      }
    },
    downLoad(file) {
      const _this = this
      const xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response
          const a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
      this.btnLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.delzhgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.cyj-table {
  tr th {
    width: 92px;
  }
}
</style>
